import { render, staticRenderFns } from "./article_e.vue?vue&type=template&id=fd0a2a1a&"
import script from "./article_e.vue?vue&type=script&lang=js&"
export * from "./article_e.vue?vue&type=script&lang=js&"
import style0 from "./article_e.vue?vue&type=style&index=0&id=fd0a2a1a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports